import { QtyDisplayColorScheme } from "../../types/types";


export const commonQtyColorSchemes:{[key:string]:QtyDisplayColorScheme} = {
    "red":{
        background:"#fef8fb",
        label:"#e2ddd7",
        value:"#c27266"
    },
    "lightgrey":{
        background:"#fafafa",
        label:"#e2ddd7",
        value:"#e2ddd7"
    },
    "grey":{
        background:"#fafafa",
        label:"#e2ddd7",
        value:"#9e9e9e"
    }
}

export type QtyColorSchemeOptions = "red" | "grey" | "lightgrey";